<template>
        <basic-container>
                 <avue-crud
                        :option="option"
                        :table-loading="loading"
                        :data="data"
                        :search.sync="searchForm"
                        :page.sync="page"
                        :permission="permissionList"
                        :before-open="beforeOpen"
                        :before-close="beforeClose"
                        v-model="form"
                        ref="crud"
                        @row-update="rowUpdate"
                        @row-save="rowSave"
                        @row-del="rowDel"
                        @search-change="searchChange"
                        @search-reset="searchReset"
                        @selection-change="selectionChange"
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        @refresh-change="refreshTable"
                        @on-load="onLoad"
                        >

                        <template slot="menu" slot-scope="scope">
                                <el-button
                                        type="text"
                                        size="small"
                                        icon="el-icon-s-finance"
                                        v-if="permissionList.charge"
                                        @click="openCarChargeDialog(scope.row)">
                                        充值
                                </el-button>
                                <el-button
                                        type="text"
                                        size="small"
                                        icon="el-icon-tickets"
                                        v-if="permissionList.chargeListBtn"
                                        @click="opentopUpdetailDialog(scope.row)">
                                        充值明细
                                </el-button>
                                <el-button
                                        type="text"
                                        size="small"
                                        icon="el-icon-sort"
                                        v-if="permissionList.carChangeBtn"
                                        @click="openCarChangeDialog(scope.row)">
                                        车牌变更
                                </el-button>
                        </template>
                        <template slot-scope="scope" slot="remark">
                                <wq-overHidden :content="scope.row.remark">
                                        <span>{{scope.row.remark}}</span>
                                </wq-overHidden>
                        </template>
                        <template slot="carBalance" slot-scope="scope">
                                {{tool.money_format_allowvoid(scope.row.carBalance)}}
                        </template>
                </avue-crud>
                <topUpdetail ref="topUpdetail"></topUpdetail>
                <carCharge ref="carCharge" @onLoad="onLoad"></carCharge>
                <carChange ref="carChange" @onLoad="onLoad"></carChange>
        </basic-container>
</template>
<script>
        import {
                add,
                getList,
                remove,
                update,
        } from '@/api/v4ward/park/storedValueCarv2/storedValueCar';

        import { getSpaceTree } from '@/api/v4ward/carv2/carparkspace';
        import { mapGetters } from 'vuex';
        import topUpdetail from "./topUpdetail.vue"
        import carCharge from "./carCharge.vue"
        import carChange from "./carChange.vue"
export default {
        components:{topUpdetail,carCharge,carChange},
        data(){
                return{
                        data: [],
                        searchForm:{},
                        form:{},
                        query:{},
                        passCloseDialog:false,
                        option: {
                                height: 'auto',
                                tip: true,
                                searchShow: true,
                                searchMenuSpan: 6,
                                border: true,
                                index: true,
                                delBtn:true,
                                addBtn: true,
                                viewBtn: false,
                                menuWidth: 300,
                                add_carMonthBtn: true,
                                selection: false,
                                selectionClearBtn:true,
                                dialogClickModal: false,
                                labelWidth: 120,
                                columnBtn: true,
                                refreshBtn: true,
                                stripe:true,
                                column: [

                                        {
                                                label: '车场名称',
                                                prop: 'spaceId',
                                                type: 'select',
                                                search:true,
                                                dicData:[],
                                                disabled:true,
                                                props: {
                                                        label: 'title',
                                                        value: 'id',
                                                        disabled: 'disabled',
                                                },
                                                rules: [
                                                        {
                                                        required: true,
                                                        message: '请选择车场',
                                                        trigger: 'change',
                                                        },
                                                ],
                                        },
                                        {
                                                label: '车牌号',
                                                prop: 'plateNumber',
                                                editDisabled: true,
                                                width: 100,
                                                search: true,
                                                rules: [
                                                        {
                                                                required: true,
                                                                message: '请输入车牌号',
                                                                trigger: 'blur',
                                                        },
                                                        {
                                                                required: true,
                                                                pattern: this.$validation.carPlate,
                                                                message: '车牌格式不对',
                                                                trigger: 'change',
                                                        },
                                                ],
                                        },
                                        {
                                                label: '车辆分类',
                                                prop: 'vehicleType7894',
                                                type: 'select',
                                                width: 80,
                                                value:'储值车',
                                                showColumn:false,
                                                disabled:true,
                                                props: { label: 'dictValue', value: 'dictKey' },
                                                rules: [
                                                        {
                                                        required: true,
                                                        message: '请选择车辆分类',
                                                        trigger: 'change',
                                                        },
                                                ],
                                        },

                                        {
                                                label: '车辆类型',
                                                prop: 'carType',
                                                type: 'select',
                                                width: 80,
                                                dicUrl: 'api/blade-system/dict/dictionary?code=car_type_v2',
                                                props: { label: 'dictValue', value: 'dictKey' },
                                                rules: [
                                                        {
                                                        required: true,
                                                        message: '请选择车辆类型',
                                                        trigger: 'change',
                                                        },
                                                ],
                                        },
                                        {
                                                label: '车辆类别',
                                                prop: 'carCategory',
                                                type: 'select',
                                                width: 80,
                                                dicUrl: 'api/blade-system/dict/dictionary?code=car_category_v2',
                                                props: { label: 'dictValue', value: 'dictKey' },
                                                rules: [
                                                        {
                                                        required: true,
                                                        message: '请选择车辆类型',
                                                        trigger: 'change',
                                                        },
                                                ],
                                        },
                                        {
                                                label: '车牌颜色',
                                                prop: 'plateColor',
                                                type: 'select',
                                                dicUrl: 'api/blade-system/dict/dictionary?code=plate_color',
                                                props: { label: 'dictValue', value: 'dictValue' },
                                                rules: [
                                                        {
                                                        required: true,
                                                        message: '请选择车牌颜色',
                                                        trigger: 'change',
                                                        },
                                                ],
                                        },
                                         {
                                                label: '车主姓名',
                                                prop: 'driverName',
                                                type: 'input',
                                                search:true,
                                                maxlength:20,
                                                showWordLimit:true,


                                        },
                                        {
                                                label: '性别',
                                                prop: 'driverSex',
                                                type: 'select',
                                                showColumn:false,
                                                dicData:[
                                                        {
                                                                label:'男',
                                                                value:'1',
                                                        },{
                                                                label:'女',
                                                                value:'2',
                                                        }
                                                ],
                                                props: { label: 'label', value: 'value' },

                                        },
                                         {
                                                label: '手机号码',
                                                prop: 'driverPhone',
                                                rules: [

                                                        {
                                                                pattern: this.$validation.phone,
                                                                message: '请输入正确的手机号',
                                                                trigger: 'change',
                                                        },
                                                ],
                                        },
                                         {
                                                label: '身份证号',
                                                prop: 'idCard',
                                                showColumn:false,
                                                rules: [
                                                        {
                                                                pattern:/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
                                                                message: '请输入正确的身份证号',
                                                                trigger: 'change',
                                                        },
                                                ],
                                        },

                                        {
                                                label: '余额',
                                                prop: 'carBalance',
                                                span: 24,
                                                slot:true,
                                                align:'right',
                                                addDisplay: false,
                                                editDisabled: true,
                                        },
                                        {
                                                label: '备注',
                                                prop: 'remark',
                                                span: 24,
                                                type: 'textarea',
                                                minRows: 2,
                                                maxlength: 100,
                                                showWordLimit: true,
                                                slot:true,
                                        },
                                ],
                        },
                }
        },
        computed: {
                ...mapGetters(['permission']),
                permissionList() {
                        return {
                                addBtn: this.vaildData(this.permission.storedValueCar_add, false),
                                viewBtn: this.vaildData(this.permission.storedValueCar_view, false),
                                delBtn: this.vaildData(this.permission.storedValueCar_delete, false),
                                editBtn: this.vaildData(this.permission.storedValueCar_edit, false),
                                chargeListBtn: this.vaildData(this.permission.storedValueCar_chargeList, false),
                                charge: this.vaildData(this.permission.storedValueCar_charge, false),
                                carChangeBtn: this.vaildData(this.permission.storedValueCar_carChange, false),
                        };
                },
                ids() {
                        let ids = [];
                        this.selectionList.forEach((ele) => {
                        ids.push(ele.id);
                        });
                        return ids.join(',');
                },
        },
        mounted(){
                this.$nextTick(() => {
                setTimeout(()=>{
                        document.querySelector('#avue-view  div.avue-crud > div.avue-crud__menu > div.avue-crud__right > button:nth-child(3)').addEventListener("click", ()=>{

                                if(this.option.height == this.bodyHeight - 340){
                                this.option.height = this.bodyHeight - 280
                                }else{
                                this.option.height = this.bodyHeight - 340;
                                }
                                this.$refs.crud.getTableHeight();
                        });
                        },1000)

                });
        },

        created(){
                this.option.height = this.bodyHeight - 340;
                this.initData();
        },
        methods:{
                openCarChangeDialog(row){
                        this.$refs.carChange.openDialog(row);
                },
                openCarChargeDialog(row){
                        this.$refs.carCharge.openDialog(row);
                },
                opentopUpdetailDialog(row){
                        this.$refs.topUpdetail.openDialog(row);
                },
                initData(){
                        getSpaceTree().then(res=>{
                                let spaceIdcolumn = this.findObject(this.option.column,'spaceId');
                                spaceIdcolumn.dicData = res.data;
                                if(res.data[0]){
                                        this.temspaceId = res.data[0].id;
                                        this.query.spaceId = res.data[0].id;
                                        this.searchForm.spaceId = res.data[0].id;
                                }
                                this.onLoad();
                        })
                },
                rowSave(row, done, loading) {
                        add(row).then(
                        () => {
                                this.passCloseDialog = true;
                                this.onLoad();
                                this.$message.success('操作成功!');
                                done();
                        },
                        (error) => {
                                window.console.log(error);
                                loading();
                        },
                        );
                },
                rowUpdate(row, index, done, loading) {
                        update(row).then(
                        () => {
                                this.passCloseDialog = true;
                                this.onLoad();
                                this.$message.success('操作成功!');
                                done();
                        },
                        (error) => {
                                window.console.log(error);
                                loading();
                        },
                        );
                },
                rowDel(row) {
                        if(row.carBalance > 0){
                                this.$message.warning('车辆【'+row.plateNumber+'】存在余额，不能删除！');
                                return;
                        }
                        this.$confirm('确定将选择数据删除?', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning',
                        })
                        .then(() => {
                                return remove({ id: row.id });
                        })
                        .then(() => {
                                this.onLoad();
                                this.$message.success('操作成功!');
                        });
                },
                beforeOpen(done, type) {
                        this.passCloseDialog = false;
                        if (['add'].includes(type)) {
                                this.form = {
                                         spaceId:this.temspaceId,
                                }

                        }
                        done();
                },
                beforeClose(done){
                        if(this.passCloseDialog){
                                done();
                        }else{
                                this.$confirm("确定关闭?", {
                                        confirmButtonText: "确定",
                                        cancelButtonText: "取消",
                                        type: "warning"
                                })
                                .then(() => {
                                        done();
                                })
                        }

                },
                searchReset() {
                        this.query = {
                                spaceId:this.temspaceId,
                        };
                        this.searchForm = {
                                spaceId:this.temspaceId,
                        }
                        this.onLoad();
                },
                searchChange(params, done) {
                        this.query = params;
                        this.page.currentPage = 1;
                        this.onLoad();
                        done();
                },
                selectionChange(list) {
                        this.selectionList = list;
                },
                selectionClear() {
                        this.selectionList = [];
                        this.$refs.crud.toggleSelection();
                },
                currentChange(currentPage) {
                        this.page.currentPage = currentPage;
                },
                sizeChange(pageSize) {
                        this.page.pageSize = pageSize;
                },
                refreshTable() {
                        this.onLoad();
                },
                onLoad(page) {
                        page = page || this.page;

                        if(!this.query.spaceId){
                                return;
                        }
                        this.loading = true;
                        this.temspaceId = this.query.spaceId;
                        getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
                                ({ data }) => {
                                this.page.total = data.total;
                                this.data = data.records;
                                this.loading = false;
                                this.selectionClear();
                                if (this.firstDisplayFlag) {
                                let ent = document.querySelector('input[placeholder="车场名称"]');
                                ent.value = this.spaceList[0].title;
                                this.query.spaceIdSearch = this.spaceList[0].id;
                                //关闭默然显示，重刷页面时才开启默认显示
                                this.firstDisplayFlag = false;
                                }
                                },
                        );
                },
        }
}
</script>
<style scoped>
  ::v-deep .avue-form__menu--center{
    text-align: right;
  }
  ::v-deep .avue-crud__search .el-form-item--small.el-form-item{
    width: 100%;
  }
</style>
